module.exports = __webpack_public_path__ + "static/img/20014 (4).119290b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20014 (4).webp
// module id = b1Pe
// module chunks = 14